<template>
    <div class="home">
        <Header :hideIpt="true"></Header>
        <div class="rich-text-page">
            <!-- 标题和时间 -->
            <div class="header">
                <h1>{{ itemData.title }}</h1>
                <p>{{$timeFormat(itemData.created_at,'YYYY年MM月DD日')  }}</p>
            </div>

            <!-- 富文本内容 -->
            <div class="content" v-html="itemData.content"></div>

            <!-- 相关产品 -->
            <div class="products-section"  v-show="itemData.label && itemData.label.length > 0">
                <h2>相关产品</h2>
                <div class="product-item" v-for="(item, index) in itemData.label" :key="index">
                    <div class="product-header" @click="toggleItem(index)">
                        <span>{{ item.title }}</span>
                        <img :class="{ 'arrow-rotated': item.isOpen }" src="@/assets/images/common/RightOutline.png"
                            alt="Arrow Icon" class="arrow-icon" />
                    </div>
                    <div v-show="item.isOpen" class="product-content">
                        <img :src="item.path" alt="Product Image" class="product-image" />
                        <div class="product-description">{{ item.description }}</div>

                    </div>
                </div>
            </div>
        </div>
        <div style="width:100%;height:64px"></div>
        <tabBar></tabBar>
    </div>
</template>
  
<script>
import tabBar from "@/components/tabBar.vue";
import Header from "@/components/header";
export default {
    components: {
        Header,
        tabBar
    },
    data() {
        return {
            itemData:{},
            title: "示例标题",
            time: "2023-10-01",
            richTextContent: `<p>这是一些富文本内容。可以包含<strong>粗体</strong>、<em>斜体</em>、以及其它HTML元素。</p>`,
            products: [
                {
                    title: "产品1",
                    path: "https://lop-oss.oss-cn-beijing.aliyuncs.com/leaderboard/202412/rc-upload-1733539341363-4.png",
                    description: "在的抗紫外稳定性在的抗紫外稳定性在的抗紫外稳定性在的抗紫外稳定性在的抗紫外稳定性在的抗紫外稳定性\n·通过内部的印刷进行品牌定制\n·防滑和防粘连添加剂",
                    isOpen: false,
                },
                {
                    title: "产品2",
                    path: "https://lop-oss.oss-cn-beijing.aliyuncs.com/leaderboard/202412/rc-upload-1733539341363-7.png",
                    description: "在的抗紫外稳定性\n·通过内部的印刷进行品牌定制\n·防滑和防粘连添加剂",
                    isOpen: false,
                },
            ],
        };
    },
    mounted() {
        this.initShare();
        this.query = this.$route.query;
        this.getDisData();
        this.$dataStatistics({
            page_title: `离型知识详情`,
        },'查看离型知识详情');
    },
    methods: {
        toggleItem(index) {
            if (this.itemData.label && this.itemData.label[index]) {
                const currentState = this.itemData.label[index].isOpen;
                this.$set(this.itemData.label[index], 'isOpen', !currentState);
            }
        },
        // toggleItem(index) {
        //     this.products[index].isOpen = !this.products[index].isOpen;
        // },
        getDisData() {
            this.$http
                .get(`/api/platform/cases/${this.query.id}`, {})
                .then((res) => {
                    this.itemData = res.data;
                    if (this.itemData.label && Array.isArray(this.itemData.label)) {
                        this.itemData.label.forEach(item => {
                            this.$set(item, 'isOpen', false); // 使用 $set 确保响应性
                        });
                    }
                    console.log('this.itemData.label ---:', this.itemData.label);
                });
        },
    },
};
</script>
  
<style lang="less" scoped>
.rich-text-page {
    max-width: 100%;
    margin: auto;
    padding: 16px 16px;
}

.header h1 {
    font-size: 20px;
    color: #333333;
    line-height: 30px;
    margin-bottom: 4px;
}

.header p {
    font-size: 12px;
    color: #9F9F9F;
    line-height: 18px;
    margin-bottom: 16px;
}

.products-section {
    margin-top: 16px;
    overflow: auto;
}

.products-section h2 {
    font-size: 16px;
    color: #333333;
    line-height: 24px;
    margin-top: 16px;
}

.product-item {
    margin-bottom: 15px;
    border-radius: 5px;
    overflow: hidden;
    margin-top: 16px;
}

.product-header {
    background: #FAFAFA;
    padding: 16px;
    cursor: pointer;
    display: flex;
    border-radius: 8px;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    color: #333333;
}

.arrow-icon {
    width: 20px;
    height: 20px;
    transition: transform 0.3s;
}

.arrow-rotated {
    transform: rotate(90deg);
}

.product-content {
    padding: 10px;
    display: flex;
    align-items: flex-start;
}

.product-description {
    flex: 1;
    white-space: pre-wrap;
    font-size: 14px;
    color: #5D5D61;
    line-height: 20px;
    /* 保留换行和空格 */
}

.product-image {
    width: 120px;
    height: auto;
    margin-right: 10px;
    border-radius: 8px 8px 8px 8px;
}
.content{
    ::v-deep li::before {
  content: "• "; /* 使用不同的符号 */
  color: #333; /* 自定义颜色 */
  font-size: 18px; /* 自定义大小 */
}
 
   ::v-deep p{
    min-height: 12px;
   }   
   ::v-deep video{
    width: 100%;
    height: auto;
   }
   ::v-deep img{
    width: 100%;
    height: auto;
   }
     
}

</style>